import { client } from "src/shared/client";
import { GetApplicationsInfo, GetCrawledApplicationsInfo } from "src/shared/dtos";

export const infoWidgetsApi = {
    getApplicationsInfo: () => client.get(new GetApplicationsInfo()),
    getCrawledApplicationsInfo: () => client.get(new GetCrawledApplicationsInfo()),
};

export default infoWidgetsApi;